var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaladiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 710 525.7",
    style: {
      enableBackground: "new 0 0 710 525.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3C3C3B;}\n\t.st1{fill:#07706D;}\n\t.st2{fill:#85BD48;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.4,199.3v25c0,8.2-6.8,15-15,15h-34.1v-76.6h-12c-2.6,0-4.7,2.1-4.7,4.7v72h-36.3V229 c0-23.5-19.1-42.6-42.6-42.6h-14.7v11.9c0,2.6,2.1,4.7,4.7,4.7h10c14.4,0,26,11.6,26,26v10.3h-43.3c-2.6,0-4.7,2.1-4.7,4.7v12h48 h7.5h45.4h8.4h42.4c17.5,0,31.6-14.1,31.6-31.6v-29.8h-12C344.4,194.6,342.4,196.7,342.4,199.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.3,239.3H85.4H72.5c-8.2,0-15-6.8-15-15v-25c0-2.6-2.1-4.7-4.7-4.7H40.9v29.5c0,17.5,14.1,31.6,31.6,31.6 h12.9h13.2H166v-12C165.9,241.3,163.8,239.3,161.3,239.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.1,263.5c-5,0-9.1,4.1-9.1,9.1c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1C320.2,267.6,316.1,263.5,311.1,263.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.6,263.5c-5,0-9.1,4.1-9.1,9.1c0,5,4.1,9.1,9.1,9.1c5,0,9.1-4.1,9.1-9.1 C126.7,267.6,122.6,263.5,117.6,263.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,263.5c-5,0-9.1,4.1-9.1,9.1c0,5,4.1,9.1,9.1,9.1c5,0,9.1-4.1,9.1-9.1C107,267.6,103,263.5,97.9,263.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.4,308.6c3.2-6.2,10.4-9,16.9-9c12.8,0,22.8,8.2,22.8,23.3c0,14.8-10,23.3-22.9,23.3 c-6.6,0-13.2-2.9-16.7-9l-0.3,8.2h-7.2v-60.1h7.5V308.6z M48.7,322.8c0,9.8,7,16.4,16,16.4c8.8,0,15.9-5.9,15.9-16.3 c0-10.6-7-16.3-15.9-16.3S48.7,313.1,48.7,322.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.5,345.6l-0.1-8.2c-3.5,6.2-10.4,9.1-16.6,9.1c-12.9,0-23.1-9-23.1-23.6c0-14.5,10.3-23.3,23.2-23.2 c6.8,0,13.4,3.1,16.7,9l0.1-8.2h7.3v44.9h-7.2L140.5,345.6z M124,306.8c-9,0-16.2,6.3-16.2,16.4c0,10,7.2,16.4,16.2,16.4 C145.8,339.7,145.8,306.7,124,306.8L124,306.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.6,
    y: 285.4,
    className: "st0",
    width: 7.5,
    height: 60.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.9,345.6l-0.1-8.2c-3.5,6.2-10.4,9.1-16.6,9.1c-12.9,0-23.1-9-23.1-23.6c0-14.5,10.3-23.3,23.2-23.2 c6.8,0,13.4,3.1,16.7,9l0.1-8.2h7.3v44.9h-7.2L229.9,345.6z M213.4,306.8c-9,0-16.2,6.3-16.2,16.4c0,10,7.2,16.4,16.2,16.4 C235.2,339.7,235.2,306.7,213.4,306.8L213.4,306.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.8,285.4v60.1h-7l-0.3-8.2c-3.7,6.2-10.1,9.1-16.9,9.1c-12.8,0-22.8-8.5-22.8-23.3 c0-15.1,10-23.3,22.6-23.3c6.3,0,13.7,2.9,16.9,9v-23.2H299.8L299.8,285.4z M276,306.5c-8.8,0-15.9,5.7-15.9,16.3 c0,10.4,7,16.3,15.9,16.3c9,0,16-6.6,16-16.4C292,313.1,284.8,306.5,276,306.5L276,306.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "350.9,300.5 340.9,324 336.1,336.8 331.2,323.9 322.3,300.5 313.9,300.5 331.9,344.9 324.3,362.8  332.2,362.8 359,300.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M535.8,129.3v30.1c-1.5,1.5-4.8,5.9-9.1,20.4c-0.1,0.3-0.6,0.6-0.9,0.3c-2.6-2.1-14.2-9.5-33.6-2.6 c-0.4,0.1-0.4,0.7,0,1c2.6,1.2,9,4.1,12.5,8.1c0.3,0.3,0,0.9-0.4,0.9c-7.3-0.3-49,0.9-81.1,51.2c-0.3,0.4,0.3,1,0.7,0.7 c7.9-5.6,36.4-24.2,61.4-22.2c0.6,0,0.7,0.7,0.1,1c-9,4.1-48.8,26-57.9,88.3c-0.1,0.6,0.7,0.9,1,0.3c5.6-9.8,28.2-46.8,59.5-59.9 c0.4-0.1,0.9,0.4,0.6,0.9c-6,7.5-30,40.7-24.8,95.4c0,0.6,0.9,0.6,1,0.1c3.2-10.6,17-52.1,40.1-77.2c0.4-0.4,1-0.1,0.9,0.4 c-1.5,9.5-8.4,56.2-0.3,92.8c0.1,0.6,1,0.4,1-0.1c1.3-13.8,7.2-68.4,19.5-85.2c0.1-0.1,0.3-0.1,0.4-0.1c0,0,0.1,0,0.4,0l2.6,33.5 H525l3.5,44.8h-4.4l2.2,44.2c-69.2-5-123.8-62.7-123.8-133.2C402.7,189.4,462.3,129.6,535.8,129.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M535.9,129.3v30.1c1.5,1.5,4.8,5.9,9.1,20.4c0.1,0.3,0.6,0.6,0.9,0.3c2.6-2.1,14.2-9.5,33.6-2.6 c0.4,0.1,0.4,0.7,0,1c-2.6,1.2-9,4.1-12.5,8.1c-0.3,0.3,0,0.9,0.4,0.9c7.3-0.3,49,0.9,81.1,51.2c0.3,0.4-0.3,1-0.7,0.7 c-7.9-5.6-36.4-24.2-61.4-22.2c-0.6,0-0.6,0.7-0.1,1c9,4.1,48.8,26,57.9,88.3c0.1,0.6-0.7,0.9-1,0.3c-5.6-9.8-28.2-46.8-59.5-59.9 c-0.4-0.1-0.9,0.4-0.6,0.9c6,7.5,30,40.7,24.8,95.4c0,0.6-0.9,0.6-1,0.1c-3.2-10.6-17-52.1-40.1-77.2c-0.4-0.4-1-0.1-0.9,0.4 c1.5,9.5,8.4,56.2,0.3,92.8c-0.1,0.6-1,0.4-1-0.1c-1.3-13.8-7.2-68.4-19.5-85.2c-0.1-0.1-0.3-0.1-0.4-0.1c0,0-0.1,0-0.4,0 l-2.6,33.5h4.6l-3.5,44.8h4.4l-2.2,44.2c69.2-5,123.8-62.7,123.8-133.2C668.8,189.4,609.3,129.6,535.9,129.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaladiLogo);
export default __webpack_public_path__ + "static/media/baladi-logo.432c095c7bb0778723d62cbf2d4ed16c.svg";
export { ForwardRef as ReactComponent };